<script>
    import { language } from '../core/i18n/language-store';
    import { translations } from '../core/i18n/translations';

    const languages = {
        ru: 'Русский',
        be: 'Беларуская',
        kk: 'Қазақша',
        uz: 'O\'zbek',
        en: 'English',
        es: 'Español',
        tr: 'Türkçe',
        ka: 'ქართული',
        ko: '한국어'
    };

    let isOpen = false;

    function toggleDropdown() {
        isOpen = !isOpen;
    }

    function selectLanguage(code) {
        language.setLanguage(code);
        isOpen = false;
    }
</script>

<style>
    .language-switcher {
        position: absolute;
        top: 1rem;
        right: 1rem;
        font-family: PT Mono, sans-serif;
        z-index: 1001;
    }

    .selected-language {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 0.75rem;
        color: var(--main-font-color);
        background: var(--bg-color);
        border-radius: 0.25rem;
        cursor: pointer;
        font-size: 14px;
        line-height: 1;
        text-transform: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }

    .globe-icon {
        flex-shrink: 0;
    }

    .dropdown {
        position: absolute;
        top: calc(100% + 0.5rem);
        right: 0;
        background: var(--bg-color);
        border-radius: 0.25rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
        opacity: 0;
        visibility: hidden;
        transform: translateY(-10px);
        transition: all 0.2s ease;
        min-width: 120px;
        border: 1px solid rgba(0, 0, 0, 0.1);
    }

    .dropdown.open {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }

    .language-option {
        display: block;
        width: 100%;
        padding: 0.75rem 1rem;
        color: var(--main-font-color);
        cursor: pointer;
        font-size: 14px;
        white-space: nowrap;
        transition: background-color 0.2s ease;
        text-align: left;
        border: none;
        background: none;
        text-transform: none;
    }

    .language-option:hover {
        background: var(--accent-color);
        color: var(--bg-color);
    }

    .language-option.active {
        background: var(--accent-color);
        color: var(--bg-color);
    }

    .chevron {
        transition: transform 0.2s ease;
    }

    .chevron.open {
        transform: rotate(180deg);
    }

    @media (min-width: 768px) {
        .language-switcher {
            top: 1.5rem;
            right: 1.5rem;
        }
    }
</style>

<div class="language-switcher">
    <div class="selected-language" on:click={toggleDropdown}>
        <svg class="globe-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5"/>
            <path d="M2.5 12H21.5" stroke="currentColor" stroke-width="1.5"/>
            <path d="M12 2.5C14.7614 2.5 17 6.81372 17 12C17 17.1863 14.7614 21.5 12 21.5C9.23858 21.5 7 17.1863 7 12C7 6.81372 9.23858 2.5 12 2.5Z" stroke="currentColor" stroke-width="1.5"/>
        </svg>
        {languages[$language]}
        <svg class="chevron" class:open={isOpen} width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
    <div class="dropdown" class:open={isOpen}>
        {#each Object.entries(languages) as [code, name]}
            {#if translations[code]}
                <button 
                    class="language-option" 
                    class:active={$language === code}
                    on:click={() => selectLanguage(code)}>
                    {name}
                </button>
            {/if}
        {/each}
    </div>
</div> 
